<template>
  <div class="report-fs">
    <!-- <div style="margin-top: 178px;" v-if="pathLogo == m"></div>
      <div style="margin-top: 35px;" v-if="pathLogo != m"></div>
      <div class="mlogo t-alignlogo">
        <img class="wlogo" :src="pathLogo" />
      </div> -->
    <!-- <h3 class="text-center fs-head-co">{{ allData.fullName }}</h3>
      <h3 class="text-center fs-head-co">{{ allData.shortName }}</h3>
      <h3 class="text-center fs-head"> عدد أيام {{ TypeT == "1" ? "الحضور المتأخر" : TypeT == "2" ? "الخروج المبكر" : TypeT == "3" ? "الغياب":""  }}  من {{ convertToUi(DateFrom) }} الى {{ convertToUi(DateTo) }}  </h3> -->
    <!-- <h3 class="text-center fs-head"> {{ DepartmentId == "" ? "" : data[0].departmentName }}</h3> -->
    <!-- <h4 class="text-left" style="margin-left: 50px; direction: ltr">
        التاريخ : {{ convertToUi(new Date()) }}
      </h4> -->

    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">التقرير الشامل للموظف</h4>
              </div>
            </md-card-header>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell
                      v-for="(item, i) in arabicName"
                      :key="i"
                      class="border-staffLists w-200"
                      >{{ item }}</md-table-cell
                    >

                    <!-- <md-table-cell v-for="(item2, j) in enName" :key="j" class="border-staffLists w-200">{{ item2
                    }}</md-table-cell> -->
                  </md-table-row>
                  <!-- <md-table-cell class="border-staffLists" md-label="الصنف">ر.ت</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">اسم الموظف</md-table-cell> -->

                  <md-table-row v-for="(item, i) in data" :key="i">
                    <md-table-cell
                      v-for="(item2, j) in enName"
                      :key="j"
                      class="border-staffLists"
                      md-label="الصنف"
                    >
                      <p
                        v-if="
                          item2 == 'BirthDate' ||
                          item2 == 'StartingDate' ||
                          item2 == 'VisaExpiryDate' ||
                          item2 == 'ContractDateFrom' ||
                          item2 == 'ContractDateTo' ||
                          item2 == 'IdentificationCardIssueDate'
                        "
                      >
                        {{ converty(item[item2]) }}
                      </p>

                      <p
                        v-else-if="
                          item2 == 'NationalityType' && item[item2] == 1
                        "
                      >
                        وطني
                      </p>

                      <p
                        v-else-if="
                          item2 == 'NationalityType' && item[item2] == 2
                        "
                      >
                        اجنبي
                      </p>

                      <p v-else>{{ item[item2] }}</p>
                    </md-table-cell>

                    <!-- <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.daysCount
                    }}</md-table-cell>

                    <md-table-cell class="border-staffLists" md-label="الصنف">
                      <div
                        style="padding-top: 10px; padding-left: 20px"
                        v-for="(item, i) in item.details"
                        :key="i"
                      >
                        {{ "(" + convert(item.date) + ")" }}
                      </div>
                    </md-table-cell> -->
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: [
    "data",
    "pathLogo",
    "allData",
    "TypeT",
    "DateFrom",
    "DateTo",
    "arabicName",
    "enName",
  ],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    converty(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>
